import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractApiService } from '@core/services';
import { environment } from '@env/environment';
import { PasswordResetSessionPayload } from './password-reset.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetApiService extends AbstractApiService<object> {
  constructor() {
    super(`${environment.backend?.url}/password-reset`);
  }

  /**
   * Call validate session token API .
   * @param {PasswordResetSessionPayload} payload - Session token and email.
   * @returns {Observable<any>} Observable of API response.
   */
  validateSessionToken(payload: PasswordResetSessionPayload): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/validate-token`, payload);
  }

  /**
   * Call password reset API .
   * @param {PasswordResetSessionPayload & { password: string }} payload - Session token, email and new password.
   * @returns {Observable<any>} Observable of API response.
   */
  changePassword(payload: { password: string } & PasswordResetSessionPayload): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/change-password`, payload);
  }
}
